import { render, staticRenderFns } from "./CommunityType.vue?vue&type=template&id=02c36010&scoped=true&"
import script from "./CommunityType.vue?vue&type=script&lang=js&"
export * from "./CommunityType.vue?vue&type=script&lang=js&"
import style0 from "./CommunityType.vue?vue&type=style&index=0&id=02c36010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c36010",
  null
  
)

export default component.exports